var req = require("!!/pub/www/atran/releases/20250211134838Z/node_modules/callback-loader/callback-loader.js!/pub/www/atran/releases/20250211134838Z/node_modules/babel-loader/lib/index.js??ref--0!/pub/www/atran/releases/20250211134838Z/frontend/components.js");
module.exports = (req['default'] || req).apply(req, [])


//////////////////
// WEBPACK FOOTER
// ./node_modules/apply-loader!./node_modules/callback-loader/callback-loader.js!./frontend/components.js
// module id = 160
// module chunks = 0